module.exports = __webpack_public_path__ + "static/educative_jupyter-15c9e0c26c8a487bfc8ad62fb840396d.webm";